module.exports = __webpack_public_path__ + "media/images/favicon-96x96-c29f74557c3351842f26cd63c458f19b.png";